export enum BioFuelType {
    'Fame' = 1,
    'HVO' = 2,
}

export const getBioFuelTypeId = (bioFuelType: BioFuelType): number | undefined => {
    return BioFuelType[bioFuelType as unknown as keyof typeof BioFuelType];
};

export const getBioFuelType = (bioFuelTypeId: number): BioFuelType | undefined => {
    return BioFuelType[bioFuelTypeId as unknown as keyof typeof BioFuelType];
};
